import React from "react";
import type { ApolloClient } from "@apollo/client";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import {
  getLinkedEmployees,
  getPendingLinkedEmployees,
} from "actions/employerActions";

import ProcessGroupsTable from "./ProcessGroupsTable";
import IconSpinner from "components/IconSpinner";
import {
  getAllEmployerAccounts,
  getAllEmployerGroups,
} from "actions/employerActions";

const mapDispatchToProps = {
  getLinkedEmployees,
  getPendingLinkedEmployees,
  getAllEmployerAccounts,
  getAllEmployerGroups,
};

const connector = connect(null, mapDispatchToProps);

type Props = WithApolloClient<ConnectedProps<typeof connector>>;

interface State {
  initialFetching: boolean;
}

class ProcessContributions extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      initialFetching: true,
    };
  }

  async componentDidMount() {
    window.analytics.page("Employer Process Contributions");
    await Promise.all([
      this.props.getAllEmployerGroups(
        this.props.client as ApolloClient<object>
      ),
      this.props.getLinkedEmployees(this.props.client as ApolloClient<object>),
      this.props.getPendingLinkedEmployees(
        this.props.client as ApolloClient<object>
      ),
      this.props.getAllEmployerAccounts(
        this.props.client as ApolloClient<object>
      ),
    ]);
    this.setState({ initialFetching: false });
  }

  render() {
    let content;
    if (this.state.initialFetching) {
      content = <IconSpinner centered />;
    } else {
      content = <ProcessGroupsTable />;
    }
    return (
      <div className="mega-container">
        <section className="page-title-wrap">
          <article className="text-cell">
            <h1 className="page-title">Process Contributions</h1>
            <p className="page-subtext">
              Process a scheduled payroll contribution for the current pay
              period.
            </p>
          </article>
        </section>
        <div className="main-content">{content}</div>
      </div>
    );
  }
}

export default connector(withApollo<Props>(ProcessContributions));
